import React, { useState } from "react";
import { Link } from "react-router-dom";
import img1 from "../../assets/img/product/1.png";
import img2 from "../../assets/img/product/2.png";
import img3 from "../../assets/img/product/3.png";
import img4 from "../../assets/img/product/4.png";
import ItemCard from "../../components/ItemCard";
import ItemsActivityButtons from "../../components/ItemsActivityButtons";
import SearchForm from "../../components/SearchForm";
import SelectCard from "../../components/SelectCard";
import SocialIcons from "../../components/social-icons/SocialIcons";
import { BinanceIcon, Close, Grid1, Grid2, Star } from "../../icon/IconTheme";
const Home = () => {
	const [grid, setGrid] = useState(false);
	const [index, setIndex] = useState("0");
	const [modalOpen, setModalOpen] = useState(false);
	return (
		<>
			<div className="filter-top-bar">
				<SearchForm />
				<ItemsActivityButtons />
				<div className="select-grp">
					<SelectCard data={data} />
					<div className="grid-grp">
						<Link
							to="#"
							className={`${!grid ? "active" : ""}`}
							onClick={() => setGrid(false)}
						>
							<Grid1 />
						</Link>
						<Link
							to="#"
							className={`${grid ? "active" : ""}`}
							onClick={() => setGrid(true)}
						>
							<Grid2 />
						</Link>
					</div>
				</div>
			</div>
			<h4 className="section-title">143 Results</h4>
			<div className="row g-2 gx-sm-3 gy-sm-4">
				{data2 &&
					data2.map((item, i) => (
						<ItemCard
							setIndex={setIndex}
							index={index}
							setModalOpen={setModalOpen}
							{...item}
							key={i}
							serial={i}
						/>
					))}
			</div>
			<Modal
				index={index}
				modalOpen={modalOpen}
				setModalOpen={setModalOpen}
			/>
		</>
	);
};
// Home Page Modal
const Modal = ({ index, setModalOpen, modalOpen }) => {
	const { img, title, price, bidder, rating, text } = data2[index];
	return (
		<>
			<div className={`__modal ${modalOpen ? "active" : ""}`}>
				<div
					className="__modal-overlay"
					onClick={() => setModalOpen(false)}
				></div>
				<div className="__modal-dialog">
					<div className="__modal-body">
						<div className="__modal-title">
							{title && <h4 className="title">{title}</h4>}
							<div
								className="__modal-close"
								onClick={() => setModalOpen(false)}
							>
								<Close />
							</div>
						</div>
						<div className="__modal-item-card">
							<img src={img} alt="" />
							<div className="content">
								{title && <h4 className="subtitle">{title}</h4>}
								{text && <p className="text">{text}</p>}
								<div className="d-flex flex-wrap justify-content-between">
									{bidder && (
										<div>
											<div className="subtext">Current Bid</div>
											<BinanceIcon /> {bidder}
										</div>
									)}
									<div className="price text-end">
										<div className="subtext">Price</div>
										<BinanceIcon /> {price}{" "}
										<span className="text-body">($54.83)</span>
									</div>
								</div>
								<div className="mt-3 rating">
									{rating === "0" && (
										<>
											<Star />
											<Star />
											<Star />
											<Star />
										</>
									)}
									{rating !== "0" && (
										<>
											<span className="me-1">({rating})</span>
											<Star />
										</>
									)}
								</div>
								<button type="button" className="cmn-btn">
									Buy {title}
								</button>
								<div className="share">Share</div>
								<SocialIcons />
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
const data = [
	{
		option: "Recently Listed",
		value: "1",
	},
	{
		option: "Last Month",
		value: "1",
	},
	{
		option: "Last Year",
		value: "1",
	},
	{
		option: "Archived",
		value: "1",
	},
];
const data2 = [
	{
		img: img1,
		title: "Hashima 1",
		price: "0.21",
		bidder: "BNB",
		rating: "0",
		text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
	},
	{
		img: img2,
		title: "Hashima 2",
		price: "0.21",
		bidder: "BNB",
		rating: "10",
		text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
	},
	{
		img: img3,
		title: "Hashima 3",
		price: "0.21",
		bidder: "BNB",
		rating: "0",
		text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
	},
	{
		img: img4,
		title: "Hashima 4",
		price: "0.21",
		bidder: "BNB",
		rating: "10",
		text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
	},
	{
		img: img1,
		title: "Hashima 5",
		price: "0.21",
		bidder: "BNB",
		rating: "0",
		text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
	},
	{
		img: img2,
		title: "Hashima 6",
		price: "0.21",
		bidder: "BNB",
		rating: "10",
		text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
	},
	{
		img: img3,
		title: "Hashima 7",
		price: "0.21",
		bidder: "BNB",
		rating: "0",
		text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
	},
	{
		img: img4,
		title: "Hashima 8",
		price: "0.21",
		bidder: "BNB",
		rating: "10",
		text: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.`,
	},
];
export default Home;
